import { ArrowLeft, GlobeHemisphereWest } from "@phosphor-icons/react";
import { text } from "../i18n.js";
import { localeHref } from "../lib/routes.js";
import type { Locale } from "../types.js";

export function NotFoundPage({ locale }: { readonly locale: Locale }) {
  const t = text(locale);
  return <section className="not-found"><div><GlobeHemisphereWest aria-hidden="true" weight="thin" /><span>404</span><h1>{t.notFoundTitle}</h1><p>{t.notFoundBody}</p><a className="primary-button" href={localeHref(locale)}><ArrowLeft aria-hidden="true" />{t.backToThemes}</a></div></section>;
}

export function LocaleGate() {
  return <main className="locale-gate"><div><h1>OpenChatGPTSkin Community</h1><p>选择浏览语言 · Choose your language</p><div><a href={localeHref("zh-CN")}>中文</a><a href={localeHref("en")}>English</a></div></div></main>;
}
